import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IPaymentState } from 'Redux/Slices/Payment/PaymentSlice';
import { SinglePaymentOffer, SubscriptionOffer } from 'api/graphql';

type TPayload = {
  zpp: SubscriptionOffer | null;
  subscriptions: (SinglePaymentOffer | SubscriptionOffer)[];
};

export const setOffers = (state: Draft<IPaymentState>, { payload }: PayloadAction<TPayload>) => {
  state.offers = {
    zpp: payload.zpp,
    subscriptions: payload.subscriptions,
  };
  state.updatedAt = Date.now();
};
